import CourseContentLayout from "./CourseContentLayout";

function SeniorCourse(props) {
  return <CourseContentLayout {...props} totalModules={6} />;
}

export default SeniorCourse;